import { COPYRIGHT_TEXT, COPYRIGHT_TITLE, copyrightLineEn, copyrightYear } from "../../../utils/copyrightNotice";
import { BODY_INK, Box, Img, INK, LogoMark, Page, pt, Text } from "../primitives";
/** Reference page 40 — closing contact page. Contact details are fixed company data. */
export function ContactPage() {
    return (<Page>
      <LogoMark x={497.8} y={344.4} w={66.6} color="#101013"/>
      {/* Arabic wordmark «ارتيكا / فن ذكي. لمسة بشرية», rendered from the reference at 6× */}
      <Img src="/proposal-assets/template/contact-wordmark.png" x={455} y={424} w={155} h={106}/>
      <Text left={81} top={693} size={22} color={BODY_INK} dir="ltr">
        info@artika.ai
      </Text>
      <Text left={81} top={731} size={22} color={INK} dir="ltr">
        www.artika.ai
      </Text>
      {/* ©️ حقوق التصاميم (utils/copyrightNotice.js) - مقابل معلومات التواصل،
          خط رفيع + نص رصاصي هادئ حتى ما ينافس التصميم */}
      <Box x={574} y={690} w={470} h={80} style={{ borderTop: `${pt(0.75)} solid #cfcfcd`, paddingTop: pt(7), direction: "rtl", color: "#6b6c6b" }}>
        <div style={{ fontSize: pt(9.5), fontWeight: 700, color: BODY_INK }}>© {COPYRIGHT_TITLE}</div>
        <div style={{ fontSize: pt(8.5), lineHeight: 1.6 }}>{COPYRIGHT_TEXT}</div>
        <div style={{ fontSize: pt(7), color: "#9a9b99", direction: "ltr", textAlign: "left", marginTop: pt(2) }}>{copyrightLineEn(copyrightYear())}</div>
      </Box>
    </Page>);
}
